import { Dataset } from '../../types/types';
import { isUnformattedFloatItem } from './isUnformattedFloatItem';

export const needsDefaultNumberFormat = (dataset: Dataset): boolean =>
  Boolean(dataset.items?.some(isUnformattedFloatItem));
